import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import { useState } from 'react';
import Typography from '@/components/atoms/typography/typography';
import Select, { SelectOption } from '@/components/molecules/select/select';
import styles from './pickup-point-select-multiple.module.scss';

export interface PickupPointSelectMultipleProps {
  /** The class name to apply */
  className?: string;
  /** The headline text */
  headline: string;
  /** The array for multiple options to choose */
  multipleOptions?: SelectOption[];
  /** An event that is triggered on click */
  onClick?: (pickupPointId: string) => void;
  /** The selected value */
  selectedValue: string;
}

const PickupPointSelectMultiple = ({
  className,
  headline,
  multipleOptions,
  onClick,
  selectedValue,
}: PickupPointSelectMultipleProps) => {
  const { t } = useI18n();

  const [selectedOption, setSelectedOption] = useState<string>(selectedValue);

  const handleChangeMultipleOption = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const selectedValue = event.target.value;

    setSelectedOption(selectedValue);
    onClick?.(selectedValue);
  };

  return (
    <div className={classNames(styles.component, className)}>
      <Select
        label={t('items.modules.bookingFlow.select')}
        onChange={handleChangeMultipleOption}
        options={multipleOptions}
        value={selectedOption}
      />

      <div className={styles.content}>
        {headline && (
          <div className={styles.headline}>
            <Typography tag="h3" tagStyle="bodyMediumBold">
              {headline}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

PickupPointSelectMultiple.displayName = 'PickupPointSelectMultiple';

export default PickupPointSelectMultiple;
